<template>
    <div class="px-4 py-2">
        <h2>Sensores</h2>
        <b-row align-h="center" cols="1">
            <b-col cols="12" lg="9">
                <sensor-filters
                    :settings="settings"
                    :loading="loading"
                    @update="update"
                />
            </b-col>
            <b-col cols="12" lg="9" class="mt-3">
                <sensor-chart
                    ref="chart"
                    :settings="settings"
                    :loading="loading"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import sleep from "@/utils/sleep";
import SensorFilters from "./components/SensorFilters";
import SensorChart from "./components/SensorChart";
import api from "../../api";

export default {
    name: "ViewSensors",
    components: {
        SensorFilters,
        SensorChart
    },
    props: {
        settings: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        source() {
            return this.settings.SOURCE;
        }
    },
    methods: {
        async update(data) {
            this.loading = true;
            await this.$nextTick();

            try {
                const response = await api.getReadings(this.source, data);
                const responseInfos = await api.getReservoirInfos(
                    this.source,
                    data.startDate,
                    data.endDate
                );
                this.$refs.chart.update(
                    data,
                    response.data,
                    responseInfos.data
                );
            } catch (error) {
                console.error(error);
            }

            await sleep(500);
            this.loading = false;
        }
    }
};
</script>
